import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';

import { AppStateStore, AppStateModel } from './app.store';

@Injectable()
export class AppStateQuery extends Query<AppStateModel> {

  constructor(protected store: AppStateStore) {
    super(store);
  }
}
